(function () {
  var header = document.getElementById('header');
  if (header) {
    addEventListener('scroll', function () {
      header.classList.toggle('shrink', scrollY > 40);
    });
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  var mt = document.querySelector('.menu-toggle');
  if (mt) {
    mt.addEventListener('click', function () { document.body.classList.toggle('mm-open'); });
  }
  document.querySelectorAll('.mobile-nav a,.mm-close').forEach(function (el) {
    el.addEventListener('click', function () { document.body.classList.remove('mm-open'); });
  });
})();
